export default "__VITE_ASSET__evcTeygK__"